const KEY = "image_host_token";

export function getToken() {
  return localStorage.getItem(KEY) || "";
}

export function setToken(token) {
  if (token) localStorage.setItem(KEY, token);
  else localStorage.removeItem(KEY);
}

export function parseJwtPayload(token) {
  if (!token) return {};
  const part = token.split(".")[1];
  if (!part) return {};
  const b64 = part.replace(/-/g, "+").replace(/_/g, "/");
  const pad = b64.length % 4 ? "=".repeat(4 - (b64.length % 4)) : "";
  try {
    return JSON.parse(atob(b64 + pad));
  } catch {
    return {};
  }
}

export function isAdminToken(token = getToken()) {
  return parseJwtPayload(token).role === "admin";
}
